import PropTypes from "prop-types";
import React from "react";
import MoreDetails from "app/pages/.shared/MoreDetails.jsx";
import Separator from "app/pages/.shared/Separator.jsx";
import PriceDetailsMobile from "app/pages/Booking/Quotation/PriceDetails/PriceDetailsMobile";
import { FormattedMessage } from "react-intl";
import { paymentTypesValues, quotationItemShape } from "app/utils/propTypes";
import classNames from "classnames";
import "./CollapsableQuotationPriceDetailsMobile.scss";
import FlexAsideButtonContainer from "app/pages/Booking/Quotation/FlexRate/FlexAsideButton";

class CollapsableQuotationPriceDetailsMobile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false,
		};
		this.onChange = this.onChange.bind(this);
	}

	onChange(isExpanded) {
		this.setState({
			expanded: isExpanded,
		});
	}

	render() {
		const { total, paymentType, ...props } = this.props;

		return (
			<div className="collapsable-quotation-price-detail">
				<FlexAsideButtonContainer />
				<MoreDetails
					expanded={this.state.expanded}
					onChange={this.onChange}
					expandedLabel={
						<div className="collapsable-quotation-price-detail__toogle-button">
							<i className="icon icon--arrow-up-grey" />
							<FormattedMessage id="price.detail.included.hide.more.label" />
						</div>
					}
					collapsedLabel={
						<div className="collapsable-quotation-price-detail__toogle-button">
							<i className="icon icon--down-grey-dark" />
							<FormattedMessage id="price.detail.included.show.more.label" />
						</div>
					}
				>
					<PriceDetailsMobile total={total} paymentType={paymentType} {...props}>
						<div
							className={classNames("collapsable-quotation-price-detail__container", {
								"collapsable-quotation-price-detail__container--expanded": this
									.state.expanded,
							})}
						>
							<Separator design="fill" />
							<a
								type="button"
								onClick={() => this.onChange(false)}
								className="collapsable-quotation-price-detail__toogle-button"
							>
								<i className="icon icon--arrow-up-grey" />
								<FormattedMessage id="price.detail.included.hide.more.label" />
							</a>
						</div>
					</PriceDetailsMobile>
				</MoreDetails>
			</div>
		);
	}
}

CollapsableQuotationPriceDetailsMobile.propTypes = {
	brand: PropTypes.string,
	expanded: PropTypes.bool,
	basePrice: quotationItemShape,
	bookingFees: quotationItemShape,
	total: PropTypes.number,
	board: PropTypes.object,
	accommodation: PropTypes.object,
	flight: PropTypes.object,
	insurance: PropTypes.object,
	transfer: PropTypes.object,
	adults: PropTypes.number,
	infants: PropTypes.number,
	paymentType: paymentTypesValues,
	included: PropTypes.arrayOf(PropTypes.string),
	notIncluded: PropTypes.arrayOf(PropTypes.string),
	promotionValue: PropTypes.number,
};

export default CollapsableQuotationPriceDetailsMobile;
